import { Mail, Phone, MapPin } from "lucide-react";
import GoldDivider from "@/components/GoldDivider";
import Reveal from "@/components/Reveal";

function PageHero() {
  return (
    <section
      data-testid="contact-hero"
      className="relative pt-40 pb-28 px-6 sm:px-12 lg:px-24 overflow-hidden"
      style={{ background: "linear-gradient(to bottom, #040A12 0%, #081323 100%)" }}
    >
      <div className="max-w-5xl mx-auto">
        <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-[#C6A75E]/80 block mb-6 reveal visible">
          Contact
        </span>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-white tracking-tight leading-tight mb-8 reveal visible reveal-delay-2">
          Let's Structure<br />
          <span className="text-[#C6A75E]/80">Your Next Opportunity</span>
        </h1>
        <div className="h-px w-14 bg-[#C6A75E]/50 mb-8 reveal visible reveal-delay-3" />
        <p className="font-sans text-base font-light text-slate-400 leading-relaxed max-w-2xl reveal visible reveal-delay-4">
          For developers, investors, and institutions operating at scale. All inquiries are handled with complete discretion.
        </p>
      </div>
    </section>
  );
}

function ContactDetails() {
  return (
    <section data-testid="contact-details" className="py-24 px-6 sm:px-12 lg:px-24 max-w-4xl mx-auto">
      <Reveal>
        <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-[#C6A75E]/80 block mb-8">
          Head Office
        </span>
      </Reveal>

      <Reveal delay={100}>
        <div
          data-testid="office-address"
          className="bg-[#081323] border border-[#C6A75E]/10 p-10"
        >
          <div className="flex items-start gap-4 mb-8">
            <MapPin size={14} strokeWidth={1} className="text-[#C6A75E]/60 mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-sans text-sm font-light text-white leading-relaxed mb-1">
                1st Floor, 4 Ho Chi Minh Sarani
              </p>
              <p className="font-sans text-sm font-light text-slate-400">
                Kolkata — 700071
              </p>
            </div>
          </div>

          <div className="h-px bg-[#C6A75E]/10 mb-8" />

          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <Mail size={13} strokeWidth={1} className="text-[#C6A75E]/60 flex-shrink-0" />
              <a
                href="mailto:info@ksggrp.com"
                data-testid="office-email"
                className="font-sans text-sm font-light text-slate-300 hover:text-[#C6A75E] transition-colors duration-400"
              >
                info@ksggrp.com
              </a>
            </div>
            <div className="flex items-center gap-4">
              <Phone size={13} strokeWidth={1} className="text-[#C6A75E]/60 flex-shrink-0" />
              <a
                href="tel:+918583013161"
                data-testid="office-phone"
                className="font-sans text-sm font-light text-slate-300 hover:text-[#C6A75E] transition-colors duration-400"
              >
                +91 85830 13161
              </a>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={300}>
        <div className="mt-8 border-l border-[#C6A75E]/20 pl-5">
          <p className="font-sans text-xs font-light text-slate-600 leading-relaxed italic">
            All engagements are conducted with strict confidentiality. We do not respond to cold outreach. Introductions are preferred.
          </p>
        </div>
      </Reveal>
    </section>
  );
}

function PhilosophyNote() {
  return (
    <section
      data-testid="contact-philosophy"
      className="py-20 px-6 sm:px-12 lg:px-24 bg-[#081323]/40 border-t border-[#C6A75E]/10"
    >
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <div className="h-px w-10 bg-[#C6A75E]/40 mx-auto mb-8" />
        </Reveal>
        <Reveal delay={150}>
          <p className="font-serif text-xl sm:text-2xl font-light text-white/80 leading-relaxed italic">
            "We are selective in the opportunities we engage with and the partners we work alongside."
          </p>
        </Reveal>
        <Reveal delay={300}>
          <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#C6A75E]/50 mt-6">
            KSG Realty &nbsp;·&nbsp; Deal Philosophy
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default function Contact() {
  return (
    <div className="bg-[#040A12]" data-testid="contact-page">
      <PageHero />
      <GoldDivider />
      <ContactDetails />
      <GoldDivider />
      <PhilosophyNote />
    </div>
  );
}
